import React from 'react';
import { connect } from 'react-redux';
import { throttle } from 'lodash';
import { CSSTransition } from 'react-transition-group';
import * as actions from 'actions';
import styles from './rootWrapper.css';

class RootWrapper extends React.Component {
  componentDidMount() {
    this.manageAnchorOnStart();
  }

  componentDidUpdate(prevProps) {
    this.manageScrollTop(prevProps);
  }

  manageAnchorOnStart = () => {
    if (!this.props.anchor) {
      this.pageWrapper.addEventListener(
        'scroll',
        throttle(this.scrollHandler, 300),
      );
    }
  };

  manageScrollTop = (prevProps) => {
    const { page, anchor } = this.props;
    if (page !== prevProps.page && !anchor) {
      this.pageWrapper.scrollTop = 0;
    }
  };

  scrollHandler = (e) => {
    if (e.target.scrollTop > 10 && this.props.logoHidden === false) {
      this.props.hideLogo(true);
    } else if (e.target.scrollTop <= 10) {
      this.props.hideLogo(false);
    }
  };

  scrollHandlerThrottled = throttle(this.scrollHandler, 300);

  render() {
    const { page, pageReady } = this.props;
    let wrapperStyles;

    if (page === 'Home' || pageReady) {
      wrapperStyles = styles.wrapperReady;
    } else {
      wrapperStyles = styles.wrapper;
    }

    return (
      <div className={styles.root}>
        <div
          ref={(wrapper) => {
            this.pageWrapper = wrapper;
          }}
          className={wrapperStyles}
          id="wrapper"
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  logoHidden: state.logoHidden,
  page: state.page,
  anchor: state.location.payload.anchor,
  pageReady: state.pageReady,
});

const mapDispatchToProps = dispatch => ({
  hideLogo: logoHidden => dispatch(actions.logoHidden(logoHidden)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RootWrapper);



// WEBPACK FOOTER //
// ./src/components/modules/RootWrapper/RootWrapper.js